const runtimeEnv =
    typeof window !== "undefined" ? (window as any).REACT_APP_ENV : undefined;
const nodeEnv =
    typeof process !== "undefined" ? process.env.NODE_ENV : undefined;
const isProd = nodeEnv === "production" || runtimeEnv === "prod";

const parseBoolean = (value: unknown): boolean | undefined => {
    if (typeof value === "boolean") return value;
    if (typeof value !== "string") return undefined;

    const normalized = value.trim().toLowerCase();
    if (["1", "true", "yes", "on"].includes(normalized)) return true;
    if (["0", "false", "no", "off"].includes(normalized)) return false;
    return undefined;
};

const runtimeLogToggle =
    typeof window !== "undefined"
        ? parseBoolean((window as any).REACT_APP_ENABLE_LOGS)
        : undefined;
const shouldLog = runtimeLogToggle ?? !isProd;

export const log = (...args: unknown[]) => {
    if (!shouldLog) return;
    console.log(...args);
};

export const warn = (...args: unknown[]) => {
    if (!shouldLog) return;
    console.warn(...args);
};

export const error = (...args: unknown[]) => {
    if (!shouldLog) return;
    console.error(...args);
};
